import axios from "~/config/axios";

export async function validateDiscount(
  code,
  email,
  courseId,
  schoolId,
  typeCheck
) {
  const response = await axios.post("/CheckDiscount", {
    code,
    validateEmail: true,
    email,
    schoolID: schoolId,
    itemID: courseId,
    ...(typeCheck ? { typeCheck } : {})
  });

  const { discount } = response.data;
  return discount;
}
